module.exports = __webpack_public_path__ + "img/info-992.eb102b0e.png";